import React from 'react';
import './DevopsCapability.css';
import img from '../devopsassets/capabilityimg.png';

export default function DevopsCapability() {
  const devopsCapabilities = [
    {
      id: 1,
      title: "Infrastructure as Code (IaC)",
      description: "We implement Infrastructure as Code to define and manage configurations using version-controlled scripts, enabling repeatable and auditable infrastructure deployments."
    },
    {
      id: 2,
      title: "Infrastructure as Code (IaC)",
      description: "We implement Infrastructure as Code to define and manage configurations using version-controlled scripts, enabling repeatable and auditable infrastructure deployments."
    },
    {
      id: 3,
      title: "Infrastructure as Code (IaC)",
      description: "We implement Infrastructure as Code to define and manage configurations using version-controlled scripts, enabling repeatable and auditable infrastructure deployments."
    },
    {
      id: 4,
      title: "Infrastructure as Code (IaC)",
      description: "We implement Infrastructure as Code to define and manage configurations using version-controlled scripts, enabling repeatable and auditable infrastructure deployments."
    },
    {
      id: 5,
      title: "Infrastructure as Code (IaC)",
      description: "We implement Infrastructure as Code to define and manage configurations using version-controlled scripts, enabling repeatable and auditable infrastructure deployments."
    }
  ];

  return (
    <div id='devops-capability' className='outsourcemainclass'>
      <h1 className='heading'>Our Configuration Management Capabilities</h1>
      <p className='subheading'>Ensuring Consistency, Control, and Automation Across Environments</p>
      
      <div className="cards card1">
        {devopsCapabilities.slice(0, 3).map((capability) => (
          <div key={capability.id} className='card'>
            <img src={img} alt={capability.title} />
            <h3>{capability.title}</h3>
            <p>{capability.description}</p>
          </div>
        ))}
      </div>
      
      <div className="cards card2">
        {devopsCapabilities.slice(3, 5).map((capability) => (
          <div key={capability.id} className='card'>
            <img src={img} alt={capability.title} />
            <h3>{capability.title}</h3>
            <p>{capability.description}</p>
          </div>
        ))}
      </div>

       <div className="cardsnew">
         {devopsCapabilities.map((capability) => (
        <div key={capability.id} className='card'>
            <img src={img} alt={capability.title} />
            <h3>{capability.title}</h3>
            <p>{capability.description}</p>
          </div>
        ))}
      </div>
    </div>
  )
}